import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Subject } from "rxjs";

import { CRUDFormControllerBase } from "src/app-client/_appCommon/base/CRUDFormControllerBase";
import { MatStepper } from '@angular/material/stepper';
import { PrescriptionDataService } from "src/app-client/_dataservices/PrescriptionDataService";
import { AppClientContext } from "src/app-client/_appCommon/base/AppClientContext";
import { BroadcastManager } from 'src/app-client/_appCommon/base/BroadcastManager';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-client-crud-prescription',
  templateUrl: './crud-prescription.component.html',
  styleUrls: ['./crud-prescription.component.css'],
  providers: [PrescriptionDataService]
})
export class CrudPrescriptionComponent extends CRUDFormControllerBase<PrescriptionDataService>
{
  @ViewChild('stepper') stepper: MatStepper;

  public setupType: number = 0;
  public showNextStepButton: boolean = false;
  public progressStepper: number = 1;
  public isCaseDetail: boolean = false;
  public prescriptionId: number = 0;
  public prescriptionStep1Data: any;
  public prescriptionStep2Data: any;
  public prescriptionStep3Data: any;
  public prescriptionStep4Data: any;
  public prescriptionStep5Data: any;
  public prescriptionStep6Data: any;
  public prescriptionStep7Data: any;
  public prescriptionStep8Data: any;
  public prescriptionStep9Data: any;

  public firstLoad: boolean = true;
  public currentStep: number = 1; 
  private unsubscribe: Subject<void> = new Subject();
  public queryParams: any = {};
  public stepNumber: number = 1;

  constructor(activatedRoute: ActivatedRoute, 
    private prescriptionDataService: PrescriptionDataService, 
    private formBuilder: FormBuilder,private cdr:ChangeDetectorRef)
  {
    super(activatedRoute, prescriptionDataService);
  }

  ngOnInit(): void
  {
    BroadcastManager.Instance.on("on-load-setup")
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(([data]: any) =>
    {
      if(!this.isCaseDetail){
        this.activatedRoute.paramMap.subscribe(params => {
          this.getDataByStep(+params.get('id'));
        });
      }
    });
  }

  ngAfterViewInit() {
    this.initializeStepper();
    this.cdr.detectChanges();
  }

  private initializeStepper(): void
  {
    this.activatedRoute.url.subscribe(url =>
    {
      this.isCaseDetail = url.toString().contains('detail');

      this.activatedRoute.paramMap.subscribe(params =>
      {
        if (this.isCaseDetail) 
        {
          this.stepper.selectedIndex = AppClientContext.Instance.setup.currentStep - 4 < 0 ? 0 : AppClientContext.Instance.setup.currentStep - 4;
          this.getDataByStep(AppClientContext.Instance.setup.currentStep - 3 < 1 ? 1 : AppClientContext.Instance.setup.currentStep - 3);
        }
        else 
        {
          this.stepper.selectedIndex = +params.get('id') - 1;
          this.getDataByStep(+params.get('id'));
        }    
      });
    });
  }

  getDataByStep(step:number){
    if(AppClientContext.Instance.setup)
    {
      this.prescriptionId = AppClientContext.Instance.setup.prescriptionId;
      this.prescriptionDataService.getPrescriptionByStep(AppClientContext.Instance.setup.id, step, this.prescriptionId).subscribe(res=>{
        this.setPrescriptionDataByStep(step, res);
      })
    }
  }

  public onChangeStepper(event: any): void
  {
    this.progressStepper = event.selectedIndex + 1;
    this.getDataByStep(event.selectedIndex + 1);
  }

  public getProgressBarPercentage(): string
  {
    return (this.progressStepper/9*100).toString().concat('%');
  }

  ngOnDestroy(): void
  {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public onSetupTypeChange(event: number): void
  {
    this.setupType = event;
  }

  setPrescriptionDataByStep(step:number, data: any){
    switch(step){
      case 1: this.prescriptionStep1Data = data; break;
      case 2: this.prescriptionStep2Data = data; break;
      case 3: this.prescriptionStep3Data = data; break;
      case 4: this.prescriptionStep4Data = data; break;
      case 5: this.prescriptionStep5Data = data; break;
      case 6: this.prescriptionStep6Data = data; break;
      case 7: this.prescriptionStep7Data = data; break;
      case 8: this.prescriptionStep8Data = data; break;
      case 9: this.prescriptionStep9Data = data; break;
    }
  }

}
